module.exports = __webpack_public_path__ + "static/media/X_TIBET.dd51ff72.svg";